import type { IconProps } from '../types/IconProps.ts';
export const Wand: IconProps = {
    name: 'Wand',
    children: [
        `<path d="m12 12-9 9M10 9H8M12 6l-1-1M15 4V2M20 9h2M15 14v2M18 12l1 1M18 6l1-1" />`,
        `<circle cx="15" cy="9" r=".5" />`,
    ]
};